import Meta from '@/components/common/Meta'
import { META_CONTENTS } from '@/v1/constants/seo'
import WhatWeShipPage from '@/v2/components/pages/public-pages/what-we-ship-page'
import { faqSectionContent, metaImages, ogImages } from '@/v2/constants/pages/public-pages/what-we-ship-page'

interface WhatWeShipPageProps {}

const Page: React.FC<WhatWeShipPageProps> = () => {
  return (
    <>
      <Meta
        title={META_CONTENTS.what_we_ship.title ?? ''}
        keywords={META_CONTENTS.what_we_ship?.keywords ?? ''}
        description={META_CONTENTS.what_we_ship?.description ?? ''}
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
        additionalData={{
          faq: faqSectionContent.questions
        }}
      />

      <WhatWeShipPage />
    </>
  )
}

export default Page
